import { render } from "./MainTitle.vue?vue&type=template&id=09581f62&scoped=true"
import script from "./MainTitle.vue?vue&type=script&lang=js"
export * from "./MainTitle.vue?vue&type=script&lang=js"

import "./MainTitle.vue?vue&type=style&index=0&id=09581f62&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09581f62"]])

export default __exports__